module.exports = __webpack_public_path__ + "img/5_003.3ae8a9fd.webp";